import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, rdata) {
  let has_admin = useDataValue({
    viewPath: props.viewPath,
    context: 'global',
    path: 'current_location.permissions.has_admin',
  })

  let user_id = useDataValue({
    viewPath: props.viewPath,
    context: 'global',
    path: 'user.id',
  })

  return useMemo(() => {
    if (!rdata) return rdata

    return has_admin
      ? rdata
      : rdata?.filter(board => board.created_by === user_id)
  }, [rdata, has_admin, user_id])
}
